import { render, staticRenderFns } from "./MtsTakipAcFormWizard.vue?vue&type=template&id=28ce2db9"
import script from "./MtsTakipAcFormWizard.vue?vue&type=script&lang=ts"
export * from "./MtsTakipAcFormWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports